<div>
  <div  class="d-flex justify-content-center align-items-center flex-wrap mx-5" *ngIf="vetrinaMeseRecords">
    <h2 class="mb-5" *ngIf="newDate">
      LA VETRINA DELLE OPPORTUNITA’ - {{(this.newDate.getMonth() + 1) | monthToString}} {{this.newDate.getFullYear()}}
    </h2>
    <div class="d-flex justify-content-center w-100">
      <p class="mb-3">Ecco i Certificates da tenere sotto osservazione selezionati dall'Ufficio Studi di Certificati e Derivati.</p>
    </div>
    <div class="d-flex justify-content-center bg-gray p-3 mb-3">
      <b> Clicca qui per scaricare la Vetrina delle opportunità, un approfondimento dedicato a una
        selezione di quasi 50 certificati scelti dal nostro Ufficio Studi. Per facilitare la consultazione,
        lo studio è suddiviso in sezioni e per ogni certificato viene riportata l'Analisi di Scenario con relativo Commento.</b>
    </div>
    <a href="https://www.certificatiederivati.it/public/report/{{pdfNavigator}}.pdf" target="_blank">
      <button class="btn-dark rounded m-4 p-2">Download PDF</button>
    </a>
    <div *ngFor="let settore of listaSettori" class="w-100 my-3">
      <main class="vetrina-mese-tables d-block">
        <div class="table-title card-header">
          <div class=" table-header d-flex">
            <h4 class="table-title">
              {{settore}}
            </h4>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table footable" data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }'>
            <thead class="thead-dark">
            <tr>
              <th [style]="header[1] === 'Descrizione' ? 'width: 40%' : 'width: 15%'" *ngFor="let header of TABLE_SORT_HEADERS">
                {{header[1]}}
              </th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let record of vetrinaMeseRecords">
              <tr *ngIf="record.settore === settore">
                <td>{{record.emittente ? record.emittente : '--'}}</td>
                <td>
                  <a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">
                    {{record.isin ? record.isin : '--'}}
                  </a>
                </td>
                <td>{{record.descrizione ? record.descrizione : '--'}}</td>
                <td>{{record.scadenza ? (record.scadenza | date:'dd/MM/yyyy') : '--'}}</td>
                <td>{{record.sottostanteBasket ? record.sottostanteBasket : '--'}}</td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
      </main>
      </div>
    </div>
  <div class="d-flex justify-content-center align-items-center flex-wrap mx-5" *ngIf="!vetrinaMeseRecords">
    <div class="d-flex justify-content-center w-100">
      <h4>Vetrina Delle Opportunità attualmente non disponibile.</h4>
    </div>
    <button class="btn-dark rounded m-4 p-2" routerLink="/menu/home">Torna in Home</button>
  </div>
</div>
